export const marketTypeToMarketId = {
  Funds: '1',
  Clubs: '2',
  FixedIncome: '3',
  VariableIncome: '4',
  Pension: '5',
  DirectTreasury: '6',
  StructuredOperations: '7',
  Cripto: '8',
};

export const emptyListProps = {
  title: 'Este cliente não possui produtos',
  description: 'Envie um nova ordem de investimentos para seus clientes.',
};
